/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST(state, data) {
    state.list = data || [];
  },
  ADD(state, data) {
    state.list.push(data);
  },
  UPDATE(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);

    state.list.splice(pos, 1, data);
  },
  REMOVE(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const index = state.list.findIndex((u) => u.id === item);
        state.list.splice(index, 1);
      });
    } else {
      const index = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(index, 1);
    }
  },
};
